import analyticsEventValues from '@/consts/analytics/analyticsEventValues';

import StatusPageShell from '../components/StatusPageShell';
import {RescheduleFlowProvider} from './ReschedulePopup/RescheduleFlowContext';
import StatusActiveDesktop from './StatusActiveDesktop';
import StatusActiveMobile from './StatusActiveMobile';

const StatusActive = () => (
    <RescheduleFlowProvider>
        <StatusPageShell
            analyticsStatus={analyticsEventValues.ACTIVE}
            Desktop={StatusActiveDesktop}
            Mobile={StatusActiveMobile}
        />
    </RescheduleFlowProvider>
);

export default StatusActive;
